import { CloseIcon } from "components/common/Icons/CloseIcon";
import { Translate } from "components/common/Translate/Translate";

interface TitleBarProps {
    close: () => void;
}

export const TitleBar = ({ close }: TitleBarProps) => {
    return (
        <div className="relative grid place-items-center py-2">
            <div className="text-lg capitalize text-black dark:text-white">
                <Translate keyName="font" />
            </div>
            <div className="absolute right-4 top-0 bottom-0 grid place-items-center">
                <div className="w-6 h-6 rounded-full bg-irGray-300 dark:bg-darkSurface-300 grid place-items-center" onClick={close}>
                    <CloseIcon />
                </div>
            </div>
        </div>
    );
};
